import * as pdfjs from "pdfjs-dist";

let globalWorker: pdfjs.PDFWorker | null = null;

export function acquirePdfjsWorker() {
    if (!globalWorker) {
        pdfjs.GlobalWorkerOptions.workerSrc = `${__PDFJS_CDN__}/build/pdf.worker.mjs`;
        globalWorker = new pdfjs.PDFWorker();
    }
    return globalWorker;
}
